/* eslint-disable import/no-unresolved */
import ReportConfigDetails from 'views/Rules/common/ReportConfigDetails';

const FFIEC031ReportConfigDetails = ({
    selectedFFIEC031Quarter, setSelectedFFIEC031Quarter, summaryQuartersFFIEC031Data, commonFFIEC031Data,
}) => (
    <ReportConfigDetails
        selectedQuarter={selectedFFIEC031Quarter}
        setSelectedQuarter={setSelectedFFIEC031Quarter}
        summaryQuartersData={summaryQuartersFFIEC031Data}
        commonData={commonFFIEC031Data}
        displayColumn="Yes"
        istopier="No"
        rule="FFIEC031"
    />
);

export default FFIEC031ReportConfigDetails;
